import { skipToken } from '@reduxjs/toolkit/query';

import { useGetCustomerPurchaseEligibilityQuery } from 'src/api/@generated/backend-api';

import { selectSelectedAccountOrThrow } from 'src/state/account/selectors';
import { useAppSelector } from 'src/state/thunk-api';

import { useProductsQuery } from './use-products-query';

export const usePurchaseEligibilityQueryStateOrThrow = () => {
  const { purchaseEligibility } = usePurchaseEligibilityQuery();

  if (!purchaseEligibility) {
    throw new Error('Purchase eligibility data must be present');
  }

  return {
    ...purchaseEligibility,
  };
};

export const usePurchaseEligibilityQuery = () => {
  const selectedAccount = useAppSelector(selectSelectedAccountOrThrow);
  const { productsResponse } = useProductsQuery();

  const { data: purchaseEligibility, isLoading } = useGetCustomerPurchaseEligibilityQuery(
    productsResponse?.products
      ? {
          partnerId: selectedAccount.partnerId,
          billingAccountId: selectedAccount.customerId,
          offerId: productsResponse.products.offerId,
        }
      : skipToken,
  );

  return { purchaseEligibility, isLoading };
};
